import React from "react";
import moment from "moment";
import { Helmet } from "react-helmet";

export const getFutureDate = (date, dayCount, format) => {
  return moment(new Date(date)).add(dayCount, "days").format(format);
};

export const qs = (params) => {
  return Object.keys(params)
    .map(
      (key) =>
        (params[key] || params[key] === false) && `${key}=${params[key]}`,
    )
    .join("&");
};

export const formatDate = (date) =>
  moment(new Date(date)).format("MMM DD, YYYY");

export const pageDescriptions = {
  "/": {
    metaDesc:
      "DeleteMyInfo will protect your company and easily eliminate personal information from the internet.",
  },
  "/subscriptions/solo": {
    metaDesc:
      "This solo plan protection is perfect for you alone who need help in removing one's information from data brokers.",
  },
  "/subscriptions/double": {
    metaDesc:
      "We offer a double plan that will protect 2 of your family's online privacy.",
  },
  "/subscriptions/family": {
    metaDesc:
      "We offer a family plan that will protect 3 to 10 people in your family's online privacy.",
  },
  "/subscriptions/solo/gift": {
    metaDesc:
      "Looking for a perfect and unique gift? This plan is perfectly fit for gifting to a special someone, a family member, or your dearest friend.",
  },
  "/subscriptions/double/gift": {
    metaDesc:
      "Looking for a perfect and unique gift? This plan is perfectly fit for gifting to a special someone, a family member, or your dearest friend.",
  },
  "/subscriptions/family/gift": {
    metaDesc:
      "Looking for a perfect and unique gift? This plan is perfectly fit for gifting to a special someone, a family member, or your dearest friend.",
  },
  "?members=3": {
    metaDesc:
      "We offer a family plan that will privacy protect 3 up to 10 people in your family.",
  },
  "/subscriptions/reputation/standard/annually": {
    metaDesc:
      "DeleteMyInfo's Standard subscription includes FREE Privacy Protection, FREE NDNC Registry (Unlimited Phone Numbers), 1 Personal Website, 21 Personalized Profiles, 25 professional Contents (Photos, Videos, Articles), and more for 1 year.",
  },
  "/subscriptions/reputation/standard/monthly": {
    metaDesc:
      "DeleteMyInfo's Standard subscription includes FREE Privacy Protection, FREE NDNC Registry (Unlimited Phone Numbers), 1 Personal Website, 21 Personalized Profiles, 25 professional Contents (Photos, Videos, Articles), and more for 1 month.",
  },
  "/subscriptions/reputation/plus/annually": {
    metaDesc:
      "DeleteMyInfo's PLUS reputation package includes 2 Personal Websites, 35 Personalized Profiles, 40 Professional Contents (Photos, Videos, Articles), and more for 1 year.",
  },
  "/subscriptions/reputation/plus/monthly": {
    metaDesc:
      "DeleteMyInfo's PLUS reputation package includes 2 Personal Websites, 35 Personalized Profiles, 40 Professional Contents (Photos, Videos, Articles), and more for 1 month.",
  },
  "/subscriptions/reputation/vip/annually": {
    metaDesc:
      "DeleteMyInfo's VIP reputation package includes FREE Privacy Protection, FREE NDNC Registry (Unlimited Phone Numbers), 3 Personal Websites, 50 Personalized Profiles, 60 Professional Content (Photos, Videos, Articles), 200+ Social Media Posts and more for 1 year.",
  },
  "/subscriptions/reputation/vip/monthly": {
    metaDesc:
      "DeleteMyInfo's VIP reputation package includes FREE Privacy Protection, FREE NDNC Registry (Unlimited Phone Numbers), 3 Personal Websites, 50 Personalized Profiles, 60 Professional Content (Photos, Videos, Articles), 200+ Social Media Posts and more for 1 month.",
  },
  "/subscriptions/reputation/vipelite/annually": {
    metaDesc:
      "DeleteMyInfo's VIP Elite package includes 60 Personalized Profiles, 80 Professional Content (Photos, Videos, Articles), 60 Personalized Profiles, 80 Professional Content (Photos, Videos, Articles), 250+ Social Media Posts, and more for 1 year.",
  },
  "/subscriptions/reputation/vipelite/monthly": {
    metaDesc:
      "DeleteMyInfo's VIP Elite package includes 60 Personalized Profiles, 80 Professional Content (Photos, Videos, Articles), 60 Personalized Profiles, 80 Professional Content (Photos, Videos, Articles), 250+ Social Media Posts, and more for 1 month.",
  },
};

export const setMetaDescription = (location) => (
  <Helmet>
    <title>
      {pageDescriptions[location?.search || location?.pathname]?.title ||
        "Delete My Info"}
    </title>
    <meta
      name="description"
      content={
        pageDescriptions[location?.search || location?.pathname]?.metaDesc ||
        "Delete Personal Data from Google"
      }
    />
  </Helmet>
);

export const googleSitesFaviconURL =
  "https://www.google.com/s2/favicons?domain=";

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const setHeadAttributes = (title, description) => {
  if (title) {
    document.title = title;
  }

  if (description) {
    let descriptionMetaTag = document.querySelector('meta[name="description"]');

    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", description);
    } else {
      descriptionMetaTag = document.createElement("meta");
      descriptionMetaTag.name = "description";
      descriptionMetaTag.content = description;
      document.head.appendChild(descriptionMetaTag);
    }
  }
};
